import { Link } from "react-router-dom";
import { categories, siteInfo } from "@/mocks/site";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-20 w-full bg-secondary-950 text-background-100">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-flashlight-fill text-lg" />
              </span>
              <span className="font-heading text-xl font-bold tracking-wide">{siteInfo.name}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              {siteInfo.slogan}。只做公开信息的整理与复盘，不追逐一时的情绪。
            </p>
            <a
              href={`mailto:${siteInfo.email}`}
              className="mt-4 inline-flex items-center gap-2 text-sm text-background-200 transition-colors hover:text-accent-400"
            >
              <i className="ri-mail-line" />
              {siteInfo.email}
            </a>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold tracking-wide text-background-50">快速导航</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-background-300 transition-colors hover:text-accent-400">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/archive" className="text-background-300 transition-colors hover:text-accent-400">
                  年度盘点
                </Link>
              </li>
              <li>
                <Link
                  to="/archive?view=review"
                  className="text-background-300 transition-colors hover:text-accent-400"
                >
                  历史复盘
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-300 transition-colors hover:text-accent-400">
                  关于本站
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold tracking-wide text-background-50">主题分类</h3>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5 text-sm lg:grid-cols-1">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/archive?category=${cat.id}`}
                    className="text-background-300 transition-colors hover:text-accent-400"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold tracking-wide text-background-50">内容说明</h3>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              本站内容均为公开信息整理，采用匿名化叙述，仅供交流参考，不构成对任何个人或机构的评价。
            </p>
            <p className="mt-3 flex items-center gap-2 text-sm text-background-300">
              <i className="ri-time-line" />
              始于 {siteInfo.since}
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>
            © {year} {siteInfo.name} · 保留所有权利
          </p>
          <p className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <span>内容仅供交流参考</span>
            <span className="hidden sm:inline">·</span>
            <span>如涉侵权请联系删除</span>
          </p>
        </div>
      </div>
    </footer>
  );
}